export enum ResultCode {
  Ok = 0,
  Error = 1,
  Captcha = 10,
}
